import React, { useEffect, useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import SearchBox from './SearchBox';
import SearchResultsBox from './SearchResultsBox';
import OrderItemPlaceholder from '../OrderItemPlaceholder';
import { STATUS, HOURS } from '../../helpers/constants';

const renderPlaceholder = () => (
  <div>
    <OrderItemPlaceholder />
    <OrderItemPlaceholder />
    <OrderItemPlaceholder />
    <OrderItemPlaceholder />
    <OrderItemPlaceholder />
    <OrderItemPlaceholder />
    <OrderItemPlaceholder />
  </div>
);

const selectStatus = ({ searchOrdersByStatus, searchStatus }) => {
  searchOrdersByStatus(searchStatus);
};

const setHoursSelected = ({ searchOrdersByHours, searchHours }) => {
  searchOrdersByHours(searchHours);
};

const onSearchText = ({ text, setSearchText, searchOrders }) => {
  setSearchText(text);
  searchOrders(text);
};

const POLL_INTERVAL = 5000;

const OrderList = ({
  orders = [],
  ordersLoaded,
  searchOrdersByStatus,
  searchOrdersByHours,
  searchStatus = STATUS[1],
  searchHours = HOURS[0],
  subscribeOrdersByStatus,
  searchOrders,
  ordersIsFetching = false,
  subscribeOrder,
  idOrderSelected = null,
  ordersError,
  selectOrder,
}) => {
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    const unsubscribeList = subscribeOrdersByStatus(searchStatus, searchHours, undefined, POLL_INTERVAL);
    return () => unsubscribeList();
  }, [searchStatus, searchHours, idOrderSelected]);

  useEffect(() => {
    let unsubscribeOrder;
    if (idOrderSelected) {
      unsubscribeOrder = subscribeOrder(idOrderSelected, POLL_INTERVAL);
    }
    return () => {
      if (unsubscribeOrder) {
        unsubscribeOrder();
      }
    };
  }, [idOrderSelected]);

  /*
  useEffect(() => {
    searchOrdersByStatus(STATUS[0], searchHours);
  }, []);
  */

  return (
    <Fragment>
      <SearchBox
        searchStatus={searchStatus}
        searchOrders={searchOrders}
        subscribeOrdersByStatus={subscribeOrdersByStatus}
        subscribeOrder={subscribeOrder}
        searchOrdersByStatus={searchOrdersByStatus}
        searchOrdersByHours={searchOrdersByHours}
        selectStatus={selectStatus}
        searchHours={searchHours}
        setHoursSelected={setHoursSelected}
        idOrderSelected={idOrderSelected}
        ordersIsFetching={ordersIsFetching}
        orders={orders}
        searchText={searchText}
        onSearchText={onSearchText}
        setSearchText={setSearchText}
      />

      <SearchResultsBox
        searchStatus={searchStatus}
        subscribeOrder={subscribeOrder}
        idOrderSelected={idOrderSelected}
        ordersIsFetching={ordersIsFetching}
        selectOrder={selectOrder}
        orders={orders}
        renderPlaceholder={renderPlaceholder}
        ordersError={!ordersLoaded ? ordersError : undefined}
      />
    </Fragment>
  );
};

OrderList.propTypes = {
  orders: PropTypes.array,
  ordersLoaded: PropTypes.bool.isRequired,
  subscribeOrdersByStatus: PropTypes.func.isRequired,
  subscribeOrder: PropTypes.func.isRequired,
  searchStatus: PropTypes.object,
  searchOrders: PropTypes.func.isRequired,
  selectOrder: PropTypes.func.isRequired,
  idOrderSelected: PropTypes.number,
  ordersIsFetching: PropTypes.bool,
  searchHours: PropTypes.object,
  ordersError: PropTypes.any,
};

OrderList.defaultProps = {
  orders: [],
  searchStatus: {},
  ordersIsFetching: false,
  idOrderSelected: null,
  searchHours: {},
  ordersError: null,
};

export default OrderList;



// WEBPACK FOOTER //
// ./src/components/OrderList/index.js